module.exports = __webpack_public_path__ + "static/google-e0605bfa7c4e5bd9d32beb1b15ce236c.png";